import axios, { AxiosResponse } from 'axios'

import { ENV } from '../../env/base'
import { appCallbackHandler } from '../../util/AppCallbackHandler'

const { BASE_URL_GL, BASE_URL_TH } = ENV()

const host = window.location.hostname
const isThHost = host.includes('.co.th')

export const AxiosInstance = axios.create({
    baseURL: isThHost ? BASE_URL_TH : BASE_URL_GL,
    headers: {
        'Content-Type': 'application/json',
    },
})

AxiosInstance.interceptors.response.use(
    async (response: AxiosResponse) => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        return response.data
    },
    (err: any) => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        const status = err.response?.status || 500

        switch (status) {
            // authentication (token related issues)
            case 401: {
                console.log('status: 401, send token again')
                window.localStorage.removeItem('token')
                window.localStorage.removeItem('MOCK_ACC_ID')
                appCallbackHandler('pageIsLoaded')
                setTimeout(() => {
                    window.location.reload()
                }, 3000)
                // if (window.location.pathname !== '/') {
                //     window.open('/', '_self')
                // }

                return Promise.reject(err.message)
            }

            // // forbidden (permission related issues)
            case 403: {
                if (
                    (err.response?.data?.message &&
                        err.response?.data?.message ===
                            'you are not allowed to change the profile name') ||
                    err.response?.data?.message ===
                        'you are not allowed to view prizes of this user'
                ) {
                    return err.response?.data?.message
                } else {
                    window.localStorage.removeItem('token')
                    window.localStorage.removeItem('MOCK_ACC_ID')
                    appCallbackHandler('pageIsLoaded')
                    console.log('status: 403, send token again')
                    setTimeout(() => {
                        window.location.reload()
                    }, 3000)
                    // if (window.location.pathname !== '/') {
                    //     window.open('/', '_self')
                    // }
                    return Promise.reject(err.message)
                }
            }

            // bad request
            case 400: {
                let errorApi: any = {}
                errorApi = err.response?.data as any
                const error = errorApi ? errorApi.message : err.message

                if (error === 'Could not find merchant info.') {
                    window.localStorage.removeItem('token')
                    window.localStorage.removeItem('MOCK_ACC_ID')
                    window.open('/')
                }
                return Promise.reject(err.response)
            }

            case 409: {
                return Promise.reject(err.message)
            }

            // unprocessable
            case 422: {
                return Promise.reject(err.message)
            }

            // generic api error (server related) unexpected
            default: {
                return Promise.reject(err.message)
            }
        }
    }
)

AxiosInstance.interceptors.request.use(
    (config: any) => {
        if (config.headers) {
            //@ts-ignore
            config.headers['x-btz-token'] = window.localStorage.getItem('token')
        }
        return config
    },

    (error) => Promise.reject(error)
)
